import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import ReactMarkdown from "react-markdown";
import { THEME_SETTINGS } from "@theme-settings";
import { MarketingInteractionTypeEnum } from "@data-types/analytics-tracker/MarketingInteractionTypeEnum";
import { ISOToDisplayCode } from "@utils";
import { analyticsTracker } from "@utils/analytics";
import { useFixBody } from "@state/hooks/shared";

export default observer(function OnboardingRegisterPopup(props: {
	isOnboardingRegisterPopupActive?: boolean;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	useFixBody(true, props.isOnboardingRegisterPopupActive);

	if (!props.isOnboardingRegisterPopupActive) {
		return null;
	}

	return (
		<div className="at-welcomeBonusModal popup popup--bonus">
			<div className="popup__card popup--bonus__card">
				<div className="popup--bonus__header">
					<img
						className="popup--bonus__logo"
						src="/assets/images/logo-vibrant.svg"
						alt=""
					/>

					<button
						type="button"
						className="popup--bonus__close btn btn--round btn--round--sml btn--primary--inverted btn--icon"
						onClick={() => {
							analyticsTracker.trackMarketingInteraction(
								MarketingInteractionTypeEnum.RegisterClose
							);
							rootStore.onboardingWelcomePopupStore.onboardingRegistrationStore.hidePopup();
						}}
					>
						<i className="u-icon u-icon--tny u-icon--close u-color--text--primary" />
					</button>
				</div>

				<div className="popup--bonus__body">
					<div className="popup--bonus__content">
						<div className="popup--bonus__text">
							<div className="popup--bonus__title">
								<ReactMarkdown>
									{t("WELCOME_BONUS.ANNOUNCEMENT", {
										amount: THEME_SETTINGS.welcomeBonusAmount,
										currency: ISOToDisplayCode(
											THEME_SETTINGS.defaultCurrency
										),
									})}
								</ReactMarkdown>
							</div>
							<div className="popup--bonus__desc">
								{t("WELCOME_BONUS.DESCRIPTION", {
									amount: THEME_SETTINGS.welcomeBonusAmount,
									currency: ISOToDisplayCode(
										THEME_SETTINGS.defaultCurrency
									),
								})}
							</div>
						</div>

						<div className="popup--bonus__footer">
							<button
								type="button"
								className="popup--bonus__btn btn btn--base btn--primary"
								onClick={() => {
									analyticsTracker.trackMarketingInteraction(
										MarketingInteractionTypeEnum.RegisterConfirm
									);
									rootStore.onboardingWelcomePopupStore.onboardingRegistrationStore.onOnboardingRedirection();
								}}
							>
								{t(
									"USER.POPUPS.ONBOARDING_WELCOME_POPUPS.REGISTRATION.REGISTER_BTN"
								)}
							</button>
						</div>
					</div>

					<div className="popup--bonus__media">
						<img
							className="popup--bonus__img"
							src="/assets/images/bg/athlete.png"
							alt=""
						/>
					</div>
				</div>
			</div>
		</div>
	);
});
